import React, {
  useState,
} from 'react'

const ICONS = {
  success: '✅',
  error: '❌',
  info: 'ℹ️',
  warning: '⚠️',
}

const COLORS = {
  success: 'bg-green-wge',
  error: 'bg-red-wge',
  info: 'bg-blue-wge',
  warning: 'bg-yellow-wge text-black',
}

const MyToaster = ({
  toast: {
    id = '',
    message = '',
    type = '',
  } = {},
} = {}) => {
  const [isVisible, setisVisible] = useState(true)
  const onToasterPress = () => setisVisible(!isVisible)

  return !!isVisible && (
    <button
      type="button"
      key={id}
      onClick={onToasterPress}
      className={`flex items-center gap-3 w-[320px] px-4 py-3 rounded-lg shadow-lg text-white animate-slide-in text-left transition-opacity hover:opacity-80 cursor-pointer ${COLORS[type] || COLORS.info}`}
    >
      <span className="text-xl">{`${ICONS[type] || ICONS.info}`}</span>
      <span className="text-sm">{`${message}`}</span>
    </button>
  )
}

export default MyToaster
